import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['copyButton']

  copy (event) {
    const button = event.currentTarget
    const textToCopy = button.getAttribute('data-copy-text')
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.showCopyFeedback(button)
      }).catch((err) => {
        console.error('コピーに失敗しました: ', err)
      })
    } else {
      this.fallbackCopy(textToCopy, button)
    }
  }

  fallbackCopy (textToCopy, button) {
    const textArea = document.createElement('textarea')
    textArea.value = textToCopy
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.showCopyFeedback(button)
    } catch (err) {
      console.error('コピーに失敗しました: ', err)
    } finally {
      textArea.remove()
    }
  }

  showCopyFeedback (button) {
    const originalText = button.textContent

    button.textContent = '完了'
    button.style.color = '#28a745'

    setTimeout(() => {
      button.textContent = originalText
      button.style.color = ''
    }, 1000)
  }
}
